export const nl = {
    rayban: {
        title: 'Ontdek Ray-Ban Meta bij geselecteerde winkels',
        subtext:
            'Benieuwd waar je de revolutionaire Ray-Ban Meta AI Glasses kunt passen en kopen?',
    },
    oakley: {
        title: 'Ontdek Oakley Meta bij geselecteerde winkels',
        subtext:
            'Benieuwd waar je de Oakley Meta AI Glasses kunt passen en kopen?',
    },
    nuance: {
        title: 'Ontdek Nuance bij geselecteerde winkels',
        subtext:
            'Op zoek naar een winkel waar je Nuance hoorbrillen kunt passen en kopen?',
    },
    searchBelow: 'Vul jouw locatie in en vind een winkel bij jou in de buurt.',
    searchPlaceholder: 'Vul je postcode of stad in',
    fromYourLocation: 'bij je vandaan',
    mapView: 'Kaart',
    listView: 'Lijst',
    makeAppointment: 'Maak een afspraak',
    viewDetails: 'Bekijk de details',
    openingHours: 'Openingstijden',
    specialOpeningHours: 'Speciale openingstijden',
    open: 'Open',
    closed: 'Gesloten',
    willOpen: 'Opent',
    at: 'om',
    today: 'vandaag',
    tomorrow: 'morgen',
    showLess: 'Toon minder winkels',
    showAll: 'Toon alle winkels',
    privacy: 'Privacy',
    terms: 'Algemene voorwaarden',
    currentLocation: 'Huidige locatie',
    useCurrentLocation: 'Gebruik mijn huidige locatie',
    errors: {
        locationNotFound: 'We kunnen je huidige locatie niet vinden',
        zipCodeNotFound: 'Deze postcode kunnen we niet vinden',
    },
    seoRayban: {
        title: 'Vind Ray-Ban Meta bij een Pearle opticien in jouw omgeving | Pearle',
        descriptionContent:
            'Vind Ray-Ban Meta bij een Pearle opticien in jouw omgeving',
    },
    seoOakley: {
        title: 'Vind Oakley Meta bij een Pearle opticien in jouw omgeving | Pearle',
        descriptionContent:
            'Vind Oakley Meta bij een Pearle opticien in jouw omgeving',
    },
    seoNuance: {
        title: 'Vind Nuance bij een Pearle opticien in jouw omgeving | Pearle',
        descriptionContent:
            'Vind Nuance bij een Pearle opticien in jouw omgeving',
    },
};
